import { CountryInfo } from '@/services/geolocation.ts';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface CountryFlagProps {
  country: CountryInfo | null;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
  className?: string;
}

export function CountryFlag({ country, size = 'md', showName = false, className = '' }: CountryFlagProps) {
  if (!country) {
    return null;
  }

  const sizeClasses = {
    sm: 'text-sm px-2 py-1',
    md: 'text-base px-3 py-1.5',
    lg: 'text-lg px-4 py-2'
  };

  const flagSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`${sizeClasses[size]} ${className} flex items-center gap-2 bg-black/40 text-white border border-white/30 hover:bg-black/50 transition-colors rounded-sm cursor-default`}
          >
            <span className={flagSizes[size]}>{country.flag}</span>
            {showName && (
              <span className="font-medium">{country.code}</span>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{country.name}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
